module.exports = __webpack_public_path__ + "img/4-11.9b857180.png";